"use strict";
exports.__esModule = true;
exports.Splitter = "<p>========================================</p>";
var CommentBoxForm = /** @class */ (function () {
    function CommentBoxForm() {
        this.keysOrder = [];
        this.form = { 'Others': { comment: '', gridType: '' } };
    }
    CommentBoxForm.prototype.parseFormComments = function (msg) {
        var _this = this;
        var json = {};
        try {
            json = JSON.parse(msg);
            // read from db and put according key-value pair, comment of un-existing keys will be added to others
        }
        catch (e) {
            if (msg) {
                this.form['Others'].comment = msg;
                return;
            }
        }
        if ('form' in json) {
            var msgForm = json['form'];
            if ('Others' in msgForm && 'comment' in msgForm['Others'] && msgForm['Others'].comment.length) {
                this.form['Others'].comment = msgForm['Others'].comment;
            }
            Object.entries(msgForm).forEach(function (_a) {
                var key = _a[0], value = _a[1];
                if (_this.keysOrder.includes(key)) {
                    if (!(key in _this.form)) {
                        _this.form[key] = { comment: '', gridType: '' };
                    }
                    if (key !== 'Others') {
                        _this.form[key].comment = value.comment || '';
                    }
                }
                else {
                    if (_this.form['Others'].comment !== '') {
                        _this.form['Others'].comment += '\n';
                    }
                    if ('comment' in value) {
                        if (value.comment !== '') {
                            _this.form['Others'].comment += key + ': ' + value.comment;
                        }
                    }
                    else {
                        _this.form['Others'].comment += value.toString();
                    }
                }
            });
        }
    };
    CommentBoxForm.prototype.toCommentStr = function () {
        var _this = this;
        var isFirstValid = true;
        var res = '';
        this.keysOrder.forEach(function (key) {
            var grid = _this.form[key];
            if (grid && grid.comment && grid.comment.trim()) {
                if (!isFirstValid) {
                    res += ', \n';
                }
                res += key + ': ' + grid.comment.trim();
                isFirstValid = false;
            }
        });
        return trimComment(res);
    };
    CommentBoxForm.prototype.toRichTextVal = function () {
        var _this = this;
        var HTMLStringGrids = [];
        this.keysOrder.map(function (key) {
            var grid = _this.form[key];
            var HTMLString = '<p><strong>' + key + '</strong>:&nbsp;' +
                grid.comment.trim() + '</p>';
            // TODO: find another way to solve this problem
            HTMLStringGrids.push(HTMLString.replace('​', '')); // clear out the empty width space
        });
        return HTMLStringGrids.join(exports.Splitter);
    };
    CommentBoxForm.prototype.isEmpty = function () {
        return Object.entries(this.form).every(function (_a) {
            var key = _a[0], value = _a[1];
            return (value.comment.trim() === '');
        });
    };
    return CommentBoxForm;
}());
exports.CommentBoxForm = CommentBoxForm;
function trimComment(comment) {
    if (comment && comment.length > 50) {
        comment = comment.substring(0, 49) + "...";
    }
    return comment;
}
//# sourceMappingURL=comment-box-form.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/input-screen/comment-box/comment-box-form.js